import type { FC } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'
import { EIconSize } from '@frontend/pole-ui/lib/components/Icon'
import { ExitIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ExitIcon'
import classNames from 'classnames'
import { Button, Image } from '@/components/ui'
import { EFinancingOfferRoute } from '@/types'
import { useWebpExtension } from '@/utils/hooks/image'
import { messages } from './messages'
import type { IPreApprovedLoanBannerProps } from './types'
import './styles.scss'

export const PreApprovedLoanBanner: FC<IPreApprovedLoanBannerProps> = ({
  title,
  description,
  className,
  logoClassName,
  titleClassName,
  descriptionClassName,
  headerClassName,
  footerClassName,
  submitButtonClassName,
  submitButtonModifiers,
  onClose,
  onClickSubmitButton,
}) => {
  const logoExtension = useWebpExtension()

  return (
    <article className={classNames(className, 'preApprovedLoanBanner')}>
      <Image
        className={classNames(logoClassName, 'preApprovedLoanBanner__logo')}
        src={`loanProducts/brand/poleFinance.${logoExtension}`}
        alt={messages.logo}
        isInStatic
      />
      <header className={classNames(headerClassName, 'preApprovedLoanBanner__header')}>
        <h5 className={classNames(titleClassName, 'preApprovedLoanBanner__title')}>{title ?? messages.title}</h5>
        <p className={classNames(descriptionClassName, 'preApprovedLoanBanner__description')}>{description ?? messages.description}</p>
      </header>

      <footer className={classNames(footerClassName, 'preApprovedLoanBanner__footer')}>
        <Link className={submitButtonClassName} to={EFinancingOfferRoute.MFOPage} onClick={onClickSubmitButton}>
          <Button className="preApprovedLoanBanner__button" modifiers={submitButtonModifiers} isFake>
            {messages.button}
          </Button>
        </Link>
      </footer>

      {onClose && (
        <Button
          onClick={onClose}
          className="preApprovedLoanBanner__closeButton"
          iconProps={{
            size: EIconSize.M,
            component: <ExitIcon />,
          }}
          isUnstyled
        />
      )}
    </article>
  )
}
